import { KyselyFilterDescSet } from '@warebee/shared/athena-db-model';
import {
  FilterFieldConfigBase,
  FilterFieldDataType,
} from '@warebee/shared/common';
import { sql } from 'kysely';
import _ from 'lodash';

function getFilterDescriptorDataTypeByConfig(
  cfg: FilterFieldConfigBase<string>,
): 'string' | 'number' {
  switch (cfg.dataType) {
    case FilterFieldDataType.IntegerRange:
    case FilterFieldDataType.NumberRange:
      return 'number';
  }

  return 'string';
}

export function getKyselyFilterDescSet<T extends string>(
  filterConfig: FilterFieldConfigBase<T>[],
): KyselyFilterDescSet<T, any, any> {
  return _.transform(
    filterConfig,
    (acc, cfg) => {
      acc[cfg.type] = [
        getFilterDescriptorDataTypeByConfig(cfg),
        eb =>
          cfg.dataType === FilterFieldDataType.Date
            ? sql`date_format(${eb.ref(cfg.type)}, '%Y-%m-%d %H:%i:%s.%f')`
            : eb.ref(cfg.type),
      ];
    },
    {} as KyselyFilterDescSet<T, any, any>,
  );
}
